import type { EngineDocument, SceneAsset } from "../scene/model";
import { copyDocument } from "./project-record";

/** Visit media resources only: a text layer containing a data URL remains literal text. */
export async function uploadDocumentMedia(
  document: EngineDocument,
  upload: (asset: SceneAsset) => Promise<string>,
): Promise<EngineDocument> {
  const snapshot = copyDocument(document);
  for (const asset of snapshot.assets) {
    if (!/^data:[^;]+;base64,/i.test(asset.source)) continue;
    const url = await upload({ ...asset });
    if (typeof url !== "string" || !url)
      throw new Error("Сервер не вернул адрес медиафайла.");
    asset.source = url;
  }
  return snapshot;
}
